// HMR-safe Action Cable consumer that auto-detects URL via action_cable_meta_tag
// Lazy initialization: the consumer is only created when getConsumer() is first called.
// This prevents WebSocket connections on unauthenticated pages (e.g., password reset).
import type { Consumer } from "@rails/actioncable";
import { createConsumer } from "@rails/actioncable";

let consumer: Consumer | null = null;

export function getConsumer(): Consumer {
  if (!consumer) {
    const meta = document.querySelector<HTMLMetaElement>(
      'meta[name="action-cable-url"]',
    );
    const url = meta?.content ?? "/cable";
    console.debug(`[Cable] Creating consumer. URL: ${url}`);
    consumer = createConsumer(url);
  }
  return consumer;
}

// HMR support for development
if (import.meta.hot) {
  import.meta.hot.dispose(() => {
    consumer?.disconnect();
    consumer = null;
  });
}
